export class Channel {
  constructor(
    public id = '26',
    public displayLabel = '(GMT-05:00) Eastern Time (US & Canada)',
  ) {}
}
